import { StoryblokComponent, storyblokEditable } from "@storyblok/react";
import { FooterBuffer } from "./FooterBuffer";

const Page = ({ blok }) => (
  <>
    <main {...storyblokEditable(blok)}>
      {blok.pagecontent
        ? blok.pagecontent.map((blok) => (
            <StoryblokComponent blok={blok} key={blok._uid} />
          ))
        : null}
    </main>

    <FooterBuffer />
  </>
);

export default Page;
